import React, {useEffect, useState, useRef, useCallback} from 'react';
import {
    Box,
    Button,
    useToast,
    VStack,
    Text,
    useDisclosure,
    Stack,
    Heading,
    Flex,
    Container,
    useColorModeValue,
    Icon,
    useBreakpointValue,
    InputGroup,
    Tooltip,
    Image,
    InputLeftAddon,
    InputRightAddon,
    Input,
    HStack,
    Badge,
    Link,
    Tabs,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
    SimpleGrid,
    Avatar,
} from '@chakra-ui/react';
import axios from 'axios';
import DocumentGrid from './DocumentGrid';
import {createThumbnail} from '../../utils/pdf-page-helpers';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../redux/AuthProvider';
import { useDispatch, useSelector } from 'react-redux';
import {
    addDocument,
    addVideo,
    setOneVideo,
    removeDocument,
    setCurrentChatInput,
    setDocuments,
    setIsPricingModalOpen,
    setIsUploadLoading,
    setScanError,
    setScanEstimatedSeconds,
    setScanFileID,
    setVideos,
    setDocumentsGeneration,
    setAudiobooks, setScanType, addAudiobook, setOutlineInAudiobook, addAudioInAudiobook
} from '../../redux/reducers';
import {addDocumentInStorage, addVideoToStorage, getDocumentsInStorage} from '../../utils/local-storage-helpers';
import {influencerMap, SERVER_IP, SERVER_IP_VIDEO} from "../../utils/constants";
import {useDropzone} from "react-dropzone";
import { motion } from 'framer-motion';
import SignUpScreen1 from "../../components/Modals/SignUp/SignUpScreen1";
import SignInScreen1 from "../../components/Modals/SignIn/SignInScreen1";
import LargeWithNewsletter from "../../components/Reuseable/LargeWithNewsletter";
import LoadingBar from "./LoadingBar";
import FullScreenTemplateHomePage from "../../templates/FullScreenTemplateHomePage";
import {
    FcAddImage,
    FcDocument, FcLock, FcMultipleInputs, FcQuestions, FcReading, FcSportsMode, FcViewDetails,
} from 'react-icons/fc'
import ReactPlayer from "react-player/lazy";
import LazyLoad from 'react-lazyload';
import lightTheme from "../../utils/styles";
import {fetchAudiobooks, fetchDocuments, fetchVideos} from "../../utils/redux-helpers";
import ScanModal1 from "../../components/Modals/Scans/ScanModal1";
import ScanModalIntro1 from "../../components/Modals/Scans/ScanModalIntro1";
import WithSpeechBubbles from "./WithSpeechBubbles";
import PricingScreen from "../../components/Modals/Payments/PricingScreen";
import '../../fonts.css';
import {useTranslation} from "react-i18next";
import LogoCarousel2 from "../../components/Reuseable/LogoCarousel2";
import URLInput from "./URLInput";
import DocumentGridVideos from "./DocumentGridVideos";
import DocumentGridGeneration from "./DocumentGridGeneration";
import DocumentGridGenerationEmpty from "./DocumentGridGenerationEmpty";
import DocumentGridVideosEmpty from "./DocumentGridVideosEmpty";
import TwoColumnLayout from "./TwoColumnLayout";
import BigTestimonial from "./BigTestimonial";
import DocumentGridEmpty from "./DocumentGridEmpty";
import {initializeMultidoc} from "../../utils/multi-doc-helpers";
import {fetchMultidocs} from "../../utils/multi-doc-helpers";
import {useServerIP} from "../../redux/ServerIPContext";
import DocumentGridAudiobooks from "./DocumentGridAudiobooks";
import DocumentGridAudiobooksEmpty from "./DocumentGridAudiobooksEmpty";
import {createAudiobook} from "../../utils/audiobook-helpers";
import { ContainerTextFlip } from "../../components/ui/container-text-flip";
import {
    initiateMultipartUpload,
    uploadMultipartParts,
    completeMultipartUpload
} from '../../utils/multipartUpload';
import {
    initiateMultipartUploadPDF,
    uploadMultipartPartsPDF,
    completeMultipartUploadPDF
} from '../../utils/multipartUploadPDF';
import {DocumentGridMembers} from "./DocumentGridMembers";
import DocumentGridMembersEmpty from "./DocumentGridMembersEmpty";
import {FileIcon} from "../../components/Reuseable/FileIcon";
import LogoCarousel3 from "../../components/Reuseable/LogoCarousel3";
import {FiEdit3, FiFileText, FiHeadphones, FiMusic, FiPlay, FiSearch, FiVideo} from "react-icons/fi";
import TypingAnimation from "../../components/Reuseable/TypingAnimation";
import FAQ2 from "../Payments/FAQ2";
import {failedPDFNotification} from "../../utils/api";

// import localForage from 'localforage';
//
// // Configure localForage to use your application's name and store name
// localForage.config({
//     name: 'MyApp',
//     storeName: 'thumbnails', // name of the datastore
// });
const MotionBox = motion(Box);

// next up. Add audiobooks here from top to bottom
const Hamlet = () => {
    const { serverIPs, setServerIPs, isDev } = useServerIP();
    const {t} = useTranslation();
    const featuresRef = useRef(null);
    const testimonialsRef = useRef(null);
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const toast = useToast();
    const fileInput = useRef();
    const fileInputAudiobook = useRef();
    const { isOpen: isOpenSignUpScreen1, onOpen: onOpenSignUpScreen1, onClose: onCloseSignUpScreen1 } = useDisclosure();
    const { isOpen: isOpenSignInScreen1, onOpen: onOpenSignInScreen1, onClose: onCloseSignInScreen1 } = useDisclosure();
    const { isOpen: isOpenScanModal1, onOpen: onOpenScanModal1, onClose: onCloseScanModal1 } = useDisclosure();
    const { isOpen: isOpenScanModalIntro1, onOpen: onOpenScanModalIntro1, onClose: onCloseScanModalIntro1 } = useDisclosure();
    const { isOpen: isOpenPricingScreen, onOpen: onOpenPricingScreen, onClose: onClosePricingScreen } = useDisclosure();
    const isUploadLoading = useSelector(state => state.settings.isUploadLoading);
    const [uploadProgress, setUploadProgress] = useState(0);
    const auth = useAuth();
    const breakpoint = useBreakpointValue({ base: 'base', sm: 'sm', md: 'md', lg: 'lg', xl: 'xl' });
    const isMobile = breakpoint === 'base' || breakpoint === 'sm';
    const fileInputVideo = useRef();

    const navigateToTestimonials = () => {
        navigate('/#testimonials');
    }

    const navigateToFeatures = () => {
        navigate('/#features');
    };

    useEffect(() => {
        const hash = window.location.hash.substring(1);
        if (hash) {
            if (hash === 'features' && featuresRef.current) {
                const offsetTop = featuresRef.current.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({ top: offsetTop - 160, behavior: 'smooth' });
            } else if (hash === 'testimonials' && testimonialsRef.current) {
                const offsetTop = testimonialsRef.current.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({ top: offsetTop - 140, behavior: 'smooth' });
            }
        }
    }, []);

    // WTFFFFFFFFFFFFFFFFFFFF
    useEffect(() => {
        const tab = searchParams.get('tab');
        if (tab === 'videos') {
            setTabIndex(2); // Set Videos tab active
        } else if (tab === 'multidoc') {
            setTabIndex(1); // Set Multidoc tab active
        } else if (tab === 'audiobooks') {
            setTabIndex(3); // Set Audio tab active
        } else if (tab === 'members') {
            setTabIndex(4); // Set Members tab active
        } else if (tab === 'bigquery') {
            setTabIndex(5); // Set BigQuery tab active
        }
        else {
            setTabIndex(0); // Default to PDFs tab
        }
    }, [searchParams]);

    const handleTabChange = (index) => {
        if (index === 0) {
            setSearchParams({ tab: 'pdfs' });
        } else if (index === 1) {
            setSearchParams({ tab: 'multidoc' });
        } else if (index === 2) {
            setSearchParams({ tab: 'videos' });
        } else if (index === 3) {
            setSearchParams({ tab: 'audiobooks' });
        } else if (index === 4) {
            setSearchParams({ tab: 'members' });
        } else if (index === 5) {
            setSearchParams({ tab: 'bigquery' });
        }
        // setSearchParams({ tab: index === 0 ? 'pdfs' : 'videos' }); // Update URL with query parameter
    };

    const onDropAudiobook = useCallback((acceptedFiles) => {
        if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
            toast({
                title: t("(Free Plan) Upload Limit Exceeded!"),
                status: "info",
                duration: 9000,
                isClosable: true,
                position: "top",
            });
            dispatch(setIsPricingModalOpen(true));
            return;
        }

        if (acceptedFiles.length > 0) {
            const file = acceptedFiles[0];
            handleFileUpload({target: {files: [file]}}, true).then(r => {
                navigate('/?tab=audiobooks');
            });
        }
    }, []);
    const {
        getRootProps: getRootPropsAudiobook,
        getInputProps: getInputPropsAudiobook,
        isDragActive: isDragActiveAudiobook
    } = useDropzone({
        onDrop: onDropAudiobook, // Correctly assign the function
        accept: 'application/pdf',
        multiple: false,
    });

    const onDrop = useCallback((acceptedFiles) => {
        if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
            toast({
                title: t("(Free Plan) PDF Upload Limit Exceeded!"),
                status: "info",
                duration: 9000,
                isClosable: true,
                position: "top",
            });
            dispatch(setIsPricingModalOpen(true));
            return;
        }

        if (acceptedFiles.length > 0) {
            const file = acceptedFiles[0];
            handleFileUpload({target: {files: [file]}}, false).then(r =>{
                navigate('/?tab=pdfs');
            });
        }
    }, []);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: 'application/pdf',
        multiple: false,
    });

    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const videoProgress = async (progress_key) => {
        while (true) {
            try {
                console.log("CALLING GENERAL_PROGRESS with key:", progress_key);
                const response = await axios.post(serverIPs.SERVER_IP + "/general_progress", {
                    key: progress_key
                });
                console.log("GENERAL_PROGRESS response:", response);
                // Resolve only if the message is not one of the waiting messages.
                // if (response.data.message !== "Starting to transcribe video" &&
                //     response.data.message !== "key not found") {
                //     return response.data.message;
                // } else if (response.data.message === "Finished transcribing video") {
                //     return response.data.message;
                // }
                if (response.data.message === "Finished transcribing video") {
                    return response.data.message;
                }
            } catch (error) {
                console.error("Error in general_progress", error);
            }
            // Wait for 5 seconds before retrying.
            await sleep(5000);
        }
    };

    const startProgressTimer = () => {
        const interval = setInterval(() => {
            setUploadProgress(prevProgress => {
                if (prevProgress < 99) {
                    // Get a random increment between 1 and 4 (inclusive)
                    const randomIncrement = Math.floor(Math.random() * 4) + 1;
                    const newProgress = Math.min(prevProgress + randomIncrement, 99);
                    return newProgress;
                } else {
                    clearInterval(interval);
                    return prevProgress;
                }
            });
        }, 3800);
        return interval;
    };


    const handleMP4Upload = async (event) => {
        dispatch(setIsUploadLoading(true));
        const file = event.target.files[0];
        // if (!file || file.type !== "video/mp4") return;

        if (!auth.isLoggedIn) {
            toast({
                title: "Please sign up to upload mp4 or mp3 files",
                status: "info",
                duration: 9000,
                isClosable: true,
                position: "top",
            });
            onOpenSignUpScreen1();
            return;
        }

        // const formData = new FormData();
        // formData.append("data_type", "file");
        // formData.append("user_id", localStorage.getItem("userID"));
        try {
            // console.log("/videos/get_file_upload_url payload", {
            //     user_id: formData.get("user_id"),
            //     filename: file.name,
            // })
            // const firstResponse = await axios.post(serverIPs.SERVER_IP + '/videos/get_file_upload_url', {
            //     user_id: formData.get("user_id"),
            //     filename: file.name,
            // });
            // console.log("firstResponse", firstResponse);
            // setUploadProgress(10);
            // const progressInterval = startProgressTimer();
            //
            // const secondResponse = await axios.put(firstResponse.data.message.presigned_url, file, {
            //     headers: {
            //         'Content-Type': 'application/mp4'
            //     }
            // });
            //
            // if (secondResponse.status === 200) {
            //     console.log('PDF uploaded successfully AWS!', secondResponse);
            //     setUploadProgress(24);
            // } else {
            //     console.error('Failed to upload PDF AWS:', secondResponse.statusText);
            // }
            // formData.append("file_id", firstResponse.data.message.file_id)
            // clearInterval(progressInterval);
            // const response = await axios.post(serverIPs.SERVER_IP + '/videos/video', formData, {
            //     onUploadProgress: (progressEvent) => {
            //         console.log("Progress Event", progressEvent);
            //         const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            //         setUploadProgress(percentCompleted);
            //     }
            // });
            // console.log('Uploaded BWC VIDEO Response:', response);
            // 1️⃣  INITIATE
            const { file_id, presigned_urls } = await initiateMultipartUpload(
                serverIPs.SERVER_IP,
                localStorage.getItem("userID"),
                file.name,
                file.size
            );
            setUploadProgress(2);

            // 2️⃣  UPLOAD PARTS—use the onPartComplete callback for exact percent
            const etagValues = await uploadMultipartParts(
                file,
                presigned_urls,
                (percent) => setUploadProgress(percent)
            );

            // 3️⃣  COMPLETE
            await completeMultipartUpload(
                serverIPs.SERVER_IP,
                localStorage.getItem("userID"),
                file_id,
                etagValues
            );
            setUploadProgress(100);

            // 4️⃣  Tell your backend to begin processing
            const formData = new FormData();
            formData.append("data_type", "file");
            formData.append("user_id", localStorage.getItem("userID"));
            formData.append("file_id", file_id);

            if (file.type === "audio/mpeg") {
                formData.append("file_type", "mp3");
            }

            dispatch(setIsUploadLoading(false));
            setUploadProgress(0);

            const response = await axios.post(
                `${serverIPs.SERVER_IP}/videos/video`,
                formData,
                {
                    onUploadProgress: ev => {
                        const pct = Math.round((ev.loaded * 100) / ev.total);
                        setUploadProgress(pct);
                    }
                }
            );

            dispatch(setIsUploadLoading(false));
            setUploadProgress(0);
            if (response.data.status === 400 && response.data.message.message === "video transcription started") {
                dispatch(addVideo({
                    id: response.data.message.file_id,
                    name: file.name,
                    url: response.data.message.video_presigned_url,
                    thumbnail_url: "",
                    isLongLoading: true,
                    highlights: [],
                    messages: [],
                    messagesGeneration: [],
                }));
                await videoProgress(response.data.message.polling_progress_key);
            }

            console.log("ADD VIDEO", response.data.message.video_presigned_url);
            dispatch(setOneVideo({
                id: response.data.message.file_id,
                name: file.name,
                url: response.data.message.video_presigned_url,
                thumbnail_url: "",
                isLongLoading: false,
                highlights: [],
                messages: [],
                messagesGeneration: [],
            }));
            toast({
                title: t("Video uploaded."),
                status: "success",
                duration: 9000,
                isClosable: true,
            });
            navigate("/?tab=videos");
        } catch (error) {
            dispatch(setIsUploadLoading(false));
            setUploadProgress(0);
            toast({
                title: t('Oops, this video failed.'),
                description: t('Please try again or upload a different video.'),
                status: "error",
                duration: 9000,
                isClosable: true,
            })
            console.error('Error uploading the video:', error);
        }
    };


    // Define the upload function based on the user authentication state
    const handleFileUpload = async (event, isAudiobook) => {
        console.log("USERID BELOW: ")
        //console.log(localStorage.getItem("userID"));

        const document = event.target.files[0];
        if (localStorage.getItem("userID") !== null) {
            if (document) {
                if (document.type === 'application/pdf') {
                    dispatch(setIsUploadLoading(true));
                    // const formData = new FormData();
                    // formData.append('file', document);
                    // formData.append('user_id', localStorage.getItem("userID"));
                    // formData.append('file_name', document.name);

                    try {
                        // 1️⃣  INITIATE
                        let response;
                        const initiateResponse = await initiateMultipartUploadPDF(
                            serverIPs.SERVER_IP,
                            localStorage.getItem("userID"),
                            document.name,
                            document.size
                        );
                        if (initiateResponse === "File size is under 10MB") {
                            const formData = new FormData();
                            formData.append('file', document);
                            formData.append('user_id', localStorage.getItem("userID"));
                            formData.append('file_name', document.name);
                            response = await axios.post(serverIPs.SERVER_IP + '/pdf', formData, {
                                onUploadProgress: (progressEvent) => {
                                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                    setUploadProgress(percentCompleted);
                                }
                            });
                        } else {
                            const file_id = initiateResponse.file_id;
                            const presigned_urls = initiateResponse.presigned_urls;
                            setUploadProgress(2);

                            // 2️⃣  UPLOAD PARTS—use the onPartComplete callback for exact percent
                            const etagValues = await uploadMultipartPartsPDF(
                                document,
                                presigned_urls,
                                (percent) => setUploadProgress(percent)
                            );

                            // 3️⃣  COMPLETE
                            await completeMultipartUploadPDF(
                                serverIPs.SERVER_IP,
                                localStorage.getItem("userID"),
                                file_id,
                                etagValues
                            );
                            setUploadProgress(100);

                            // 4️⃣  Tell your backend to begin processing
                            const formData = new FormData();
                            formData.append('file_id', file_id);
                            formData.append('user_id', localStorage.getItem("userID"));
                            formData.append('file_name', document.name);

                            response = await axios.post(
                                `${serverIPs.SERVER_IP}/pdf`,
                                formData,
                                {
                                    onUploadProgress: ev => {
                                        const pct = Math.round((ev.loaded * 100) / ev.total);
                                        setUploadProgress(pct);
                                    }
                                }
                            );
                            // setUploadProgress(0);
                            // dispatch(setIsUploadLoading(false));
                        }
                        console.log('Uploaded PDF Document Response:', response);
                        // export const createAudiobook = async (file_id, user_id, serverIP, toast) => {
                        if (isAudiobook && response.data.status !== 207) {
                            // kicks off an async job.
                            console.log("create_audiobook_clicked");
                            createAudiobook(response.data.file_id, localStorage.getItem("userID"), serverIPs.SERVER_IP, toast).then(r => {
                                // at this point the new upload is on the grid view. Either call /start_session right automatically or wait for
                                // the user to click on the grid item
                                console.log("createAudiobook response", r);
                                // dispatch(setOutlineInAudiobook({documentID: response.data.file_id, outline: r.outline}));
                                // [{
                                //     start_page: 0,
                                //     end_page: 0,
                                //     title: "Chapter 1",
                                // }, {
                                //     start_page: 0,
                                //     end_page: 0,
                                //     title: "Chapter 2",
                                // }]

                            });
                        }


                        if (response.data.status === 207) {
                            if (isAudiobook) {
                                dispatch(setScanType("audiobook"));
                            } else {
                                dispatch(setScanType("normal"));
                            }
                            dispatch(setScanFileID(response.data.message.file_id));
                            dispatch(setScanEstimatedSeconds(response.data.message.time_estimate_seconds));
                            dispatch(setIsUploadLoading(false));
                            setUploadProgress(0);
                            onOpenScanModal1();
                            dispatch(setScanError(false));
                            if (isAudiobook) {
                                dispatch(addAudiobook({
                                    id: response.data.message.file_id,
                                    name: response.data.message.filename,
                                    url: response.data.message.url,
                                    highlights: [],
                                    messages: [],
                                    outline: [],
                                    pageAudioURLs: [],
                                }));
                            } else {
                                dispatch(addDocument({
                                    id: response.data.message.file_id,
                                    name: response.data.message.filename,
                                    url: response.data.message.url,
                                    highlights: [],
                                    messages: [],
                                    messagesGeneration: [],
                                }));
                            }
                            return;
                        }



                        dispatch(setIsUploadLoading(false));
                        setUploadProgress(0);
                        if (response.data.status === 400) {
                            toast({
                                title: t("PDF is too large."),
                                description: t("We support up to 512 MB or 147,000 words"),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                        } else if (response.data.status === 401) {
                            toast({
                                title: t("Oops, this PDF failed."),
                                description: t("Please try again or upload a different PDF."),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                            failedPDFNotification(localStorage.getItem("userID"), "Single Doc Upload Fail for user " + localStorage.getItem("userID"),
                                document, serverIPs.SERVER_IP)
                        }
                        else if (response.data.status === 402 && response.data.message === "free tier exceeded. Please subscribe to continue using the service") {
                            console.log("pricing_modal_shown")
                            dispatch(setIsPricingModalOpen(true));
                            localStorage.setItem("isUploadExceeded", "true");
                            toast({
                                title: t("(Free Plan) PDF Upload Limit Exceeded!"),
                                status: "info",
                                duration: 9000,
                                isClosable: true,
                                position: "top",
                            });
                        }
                        else if (response.data.status === 402 && response.data.message === "PDF is corrupted, try uploading a different PDF") {
                            toast({
                                title: t("Oops, this PDF has corrupted bytes or is malformed"),
                                description: t("Please try again. (Or try converting it to DOCX and back to PDF and upload that new PDF)"),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                            failedPDFNotification(localStorage.getItem("userID"), "Single Doc Upload Fail for user " + localStorage.getItem("userID"), document, serverIPs.SERVER_IP)
                        }
                        else if (response.data.status === 403) {
                            toast({
                                title: t("Free Plan supports <= 20 pages for scanned PDFs"),
                                description: t("Visit honeybear.ai/pricing to view Pro Plan pricing"),
                                status: "error",
                                duration: null,
                                isClosable: true,
                            })
                        }
                        else if (response.data.status === 404) {
                            toast({
                                title: t("Scanned PDF Too Large"),
                                description: t("Pro Plan supports up to 200 pages for scanned PDFs"),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                        }
                        else {
                            if (isAudiobook) {
                                console.log("add audiobook here");
                                dispatch(addAudiobook({
                                    id: response.data.file_id,
                                    name: response.data.filename,
                                    url: response.data.url,
                                    highlights: [],
                                    messages: [],
                                    outline: [],
                                    pageAudioURLs: [],
                                }));
                                toast({
                                    title: t("Uploaded."),
                                    status: "success",
                                    duration: 9000,
                                    isClosable: true,
                                });
                            } else {
                                dispatch(addDocument({
                                    id: response.data.file_id,
                                    name: response.data.filename,
                                    url: response.data.url,
                                    highlights: [],
                                    messages: [],
                                    messagesGeneration: [],
                                }));
                                toast({
                                    title: t("Document uploaded."),
                                    status: "success",
                                    duration: 9000,
                                    isClosable: true,
                                });
                            }
                        }
                    } catch (error) {
                        dispatch(setIsUploadLoading(false));
                        setUploadProgress(0);
                        toast({
                            title: t("Oops, this PDF failed."),
                            description: t("Please try again or upload a different PDF."),
                            status: "error",
                            duration: 9000,
                            isClosable: true,
                        })
                        failedPDFNotification(localStorage.getItem("userID"), "Single Doc Upload Fail for user " + localStorage.getItem("userID"), document, serverIPs.SERVER_IP)
                        console.error('Error uploading the document:', error);
                    }
                } else {
                    toast({
                        title: t("Single-Upload only supports PDFs"),
                        description: t("Click the 'Multi-Upload' tab at the top to upload other file types"),
                        status: "error",
                        duration: 20000,
                        isClosable: true,
                    })
                }
            }
        } else {
            if (document) {
                if (getDocumentsInStorage().length === 1) {
                    toast({
                        title: t("You've reached your document limit in guest mode!"),
                        description: t("Please sign up to continue uploading documents."),
                        status: "info",
                        duration: 9000,
                        isClosable: true,
                        position: "top",
                    });
                    onOpenSignUpScreen1()
                    return;
                }
                if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
                    toast({
                        title: t("(Free Plan) PDF Upload Limit Exceeded!"),
                        status: "info",
                        duration: 9000,
                        isClosable: true,
                        position: "top",
                    });
                    dispatch(setIsPricingModalOpen(true));
                    return;
                }
                if (document.type === 'application/pdf') {
                    dispatch(setIsUploadLoading(true));
                    const formData = new FormData();
                    formData.append('file', document);
                    formData.append('user_id', "11111111-1111-1111-1111-111111111111");
                    formData.append('file_name', document.name);
                    try {
                        const response = await axios.post(serverIPs.SERVER_IP + '/pdf', formData, {
                            onUploadProgress: (progressEvent) => {
                                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                setUploadProgress(percentCompleted);
                            }
                        });



                        if (response.data.status === 207) {
                            dispatch(setScanType("normal"));
                            dispatch(setScanFileID(response.data.message.file_id));
                            dispatch(setScanEstimatedSeconds(response.data.message.time_estimate_seconds));
                            dispatch(setIsUploadLoading(false));
                            setUploadProgress(0);
                            onOpenScanModal1();
                            dispatch(setScanError(false));
                            dispatch(addDocument({
                                id: response.data.message.file_id,
                                name: response.data.message.filename,
                                url: response.data.message.url,
                                highlights: [],
                                messages: [],
                                messagesGeneration: [],
                            }));
                            return;
                        }



                        dispatch(setIsUploadLoading(false));
                        setUploadProgress(0);
                        if (response.data.status === 400) {
                            toast({
                                title: t("PDF is too large."),
                                description: t("We support up to 512 MB or 147,000 words"),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                        }
                        else if (response.data.status === 401) {
                            toast({
                                title: t("Oops, this PDF failed."),
                                description: t("Please try again or upload a different PDF."),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                            failedPDFNotification("11111111-1111-1111-1111-111111111111", "Single Doc Guest Upload Fail", document, serverIPs.SERVER_IP)
                        }
                        else if (response.data.status === 402) {
                            toast({
                                title: t("Oops, this PDF failed."),
                                description: t("Please try again or upload a different PDF."),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                            failedPDFNotification("11111111-1111-1111-1111-111111111111", "Single Doc Guest Upload Fail", document, serverIPs.SERVER_IP)
                        } else if (response.data.status === 403) {
                            toast({
                                title: t("Free Plan supports <= 20 pages for scanned PDFs"),
                                description: t("Visit honeybear.ai/pricing to view Pro Plan pricing"),
                                status: "error",
                                duration: null,
                                isClosable: true,
                            })
                        }
                        else if (response.data.status === 404) {
                            toast({
                                title: t("Scanned PDF Too Large"),
                                description: t("Pro Plan supports up to 200 pages for scanned PDFs"),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                        }
                        else {
                            addDocumentInStorage({
                                id: response.data.file_id,
                                name: response.data.filename,
                                url: response.data.url,
                                highlights: [],
                                messages: [],
                                messagesGeneration: [],
                            })
                            auth.setPlaygroundDocuments(getDocumentsInStorage());
                            dispatch(addDocument({
                                id: response.data.file_id,
                                name: response.data.filename,
                                url: response.data.url,
                                highlights: [],
                                messages: [],
                                messagesGeneration: [],
                            }));
                            toast({
                                title: t("Document uploaded."),
                                status: "success",
                                duration: 9000,
                                isClosable: true,
                            })
                        }

                    } catch (error) {
                        dispatch(setIsUploadLoading(false));
                        setUploadProgress(0);
                        toast({
                            title: t("Oops, this PDF failed."),
                            description: t("Please try again or upload a different PDF."),
                            status: "error",
                            duration: 9000,
                            isClosable: true,
                        })
                        failedPDFNotification("11111111-1111-1111-1111-111111111111", "Single Doc Guest Upload Fail", document, serverIPs.SERVER_IP)
                        console.error('Error uploading the document:', error);
                    }
                } else {
                    toast({
                        title: t("Single-Upload only supports PDFs"),
                        description: t("Click the 'Multi-Upload' tab at the top to upload other file types"),
                        status: "error",
                        duration: 20000,
                        isClosable: true,
                    })
                }
            }
        }
    };

    const handleYoutubeLinkUpload = async (url) => {
        console.log("YOUTUBE URL", url);
        if (localStorage.getItem("userID") !== null) {
            if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
                toast({
                    title: t("(Free Plan) Video Upload Limit Exceeded!"),
                    status: "info",
                    duration: 9000,
                    isClosable: true,
                    position: "top",
                });
                dispatch(setIsPricingModalOpen(true));
                return;
            }
            // toast({
            //     title: "Sorry, YouTube videos are not working at the moment.",
            //     description: "Google has changed their API and we are working on a fix. Please try again later.",
            //     status: "error",
            //     duration: 10000,
            //     isClosable: true,
            // })
            // return;
            dispatch(setIsUploadLoading(true));
            const formData = new FormData();
            formData.append('yt_link', url);
            formData.append('data_type', "yt_link");
            formData.append('user_id', localStorage.getItem("userID"));

            // console.log("video input", {
            //     yt_link: url,
            //     data_type: "yt_link",
            //     user_id: localStorage.getItem("userID"),
            // })
            try {
                const response = await axios.post(serverIPs.SERVER_IP_VIDEO + '/videos/video', formData, {
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(percentCompleted);
                    }
                });
                console.log('Uploaded Video Response new:', response);
                dispatch(setIsUploadLoading(false));
                setUploadProgress(0);
                if (response.data.status === 400 && (response.data.message === "Invalid YouTube link" || response.data.message === "Invalid video ID")) {
                    console.log("video_upload_error")
                    toast({
                        title: t("Invalid YouTube link"),
                        description: t("Please enter a valid YouTube link"),
                        status: "error",
                        duration: 9000,
                        isClosable: true,
                    })
                }
                else if (response.data.status === 400 && response.data.message === "YouTube request failed") {
                    addVideoToStorage(url)
                    navigate(`/youtube/${encodeURIComponent(url)}`);
                    console.log("video_upload_error")
                    // toast({
                    //     title: t("Upload Failed"),
                    //     description: t("Please try again or upload a different video"),
                    //     status: "error",
                    //     duration: 9000,
                    //     isClosable: true,
                    // })
                }
                else if (response.data.status === 400 && response.data.message === "Video unavailable") {
                    addVideoToStorage(url)
                    navigate(`/youtube/${encodeURIComponent(url)}`);
                    console.log("video_upload_error")
                    // toast({
                    //     title: t("Video is unavailable"),
                    //     description: t("Please make sure it's not a private video"),
                    //     status: "error",
                    //     duration: 9000,
                    //     isClosable: true,
                    // })
                }
                else if (response.data.status === 400 && (response.data.message === "No transcript available"
                    || response.data.message === "No transcript found" || response.data.message === "Transcript is None for some reason")) {
                    console.log("encoded url", encodeURIComponent(url));
                    addVideoToStorage(url)
                    navigate(`/youtube/${encodeURIComponent(url)}`);
                    console.log("video_upload_error")
                    // toast({
                    //     title: "Video Upload Succeeded",
                    //     description: "",
                    //     status: "error",
                    //     duration: 9000,
                    //     isClosable: true,
                    // })
                }
                else if (response.data.status === 400 && response.data.message.startsWith("Error getting transcript:")) {
                    addVideoToStorage(url)
                    navigate(`/youtube/${encodeURIComponent(url)}`);
                    console.log("video_upload_error")
                    // toast({
                    //     title: t("Please try again!"),
                    //     description: t("If the issue persists, please try a different video as this video may not have a transcript"),
                    //     status: "error",
                    //     duration: 9000,
                    //     isClosable: true,
                    // })
                }
                else if (response.data.status === 400 && response.data.message.startsWith("Error: ")) {
                    addVideoToStorage(url)
                    navigate(`/youtube/${encodeURIComponent(url)}`);
                    console.log("video_upload_error")
                    // toast({
                    //     title: t("Please try again!"),
                    //     description: t("If the issue persists, please try a different video"),
                    //     status: "error",
                    //     duration: 9000,
                    //     isClosable: true,
                    // })
                }
                else if (response.data.status === 400
                    && response.data.message === "Video transcript too big, try working with a smaller video") {
                    console.log("video_upload_error")
                    toast({
                        title: t("Video too large"),
                        description: t("Please try a shorter length video"),
                        status: "error",
                        duration: 9000,
                        isClosable: true,
                    })
                }
                else if (response.data.status === 402 && response.data.message === "free tier exceeded. Please subscribe to continue using the service") {
                    console.log("pricing_modal_shown")
                    dispatch(setIsPricingModalOpen(true));
                    localStorage.setItem("isUploadExceeded", "true");
                    toast({
                        title: t("(Free Plan) Upload Limit Exceeded!"),
                        status: "info",
                        duration: 9000,
                        isClosable: true,
                        position: "top",
                    });
                }
                else {
                    console.log("video_upload_success")
                    dispatch(addVideo({
                        id: response.data.file_id,
                        name: response.data.filename,
                        url: response.data.url,
                        thumbnail_url: response.data.thumbnail_presigned_url,
                        highlights: [],
                        messages: [],
                        messagesGeneration: [],
                    }));
                    toast({
                        title: t("Video uploaded."),
                        status: "success",
                        duration: 9000,
                        isClosable: true,
                    });
                }
            } catch (error) {
                addVideoToStorage(url)
                navigate(`/youtube/${encodeURIComponent(url)}`);
                console.log("video_upload_error")
                dispatch(setIsUploadLoading(false));
                setUploadProgress(0);
                // toast({
                //     title: t("Oops, this Video Upload failed."),
                //     description: t("Please try again or upload a different video."),
                //     status: "error",
                //     duration: 9000,
                //     isClosable: true,
                // })
                console.error('Error uploading the video:', error);
            }
        }
        // else {
        //         if (getDocumentsInStorage().length === 1) {
        //             toast({
        //                 title: t("You've reached your document limit in guest mode!"),
        //                 description: t("Please sign up to continue uploading documents."),
        //                 status: "info",
        //                 duration: 9000,
        //                 isClosable: true,
        //                 position: "top",
        //             });
        //             onOpenSignUpScreen1()
        //             return;
        //         }
        //         if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
        //             toast({
        //                 title: t("(Free Plan) PDF Upload Limit Exceeded!"),
        //                 status: "info",
        //                 duration: 9000,
        //                 isClosable: true,
        //                 position: "top",
        //             });
        //             dispatch(setIsPricingModalOpen(true));
        //             return;
        //         }
        //         dispatch(setIsUploadLoading(true));
        //         try {
        //             const response = await axios.post(SERVER_IP + '/videos/video', {
        //                 yt_link: url,
        //                 data_type: "yt_link",
        //                 user_id: "11111111-1111-1111-1111-111111111111",
        //             }, {
        //                 onUploadProgress: (progressEvent) => {
        //                     const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        //                     setUploadProgress(percentCompleted);
        //                 }
        //             });
        //             dispatch(setIsUploadLoading(false));
        //             setUploadProgress(0);
        //             if (response.data.status === 400) {
        //                 toast({
        //                     title: t("PDF is too large."),
        //                     description: t("We support up to 512 MB or 147,000 words"),
        //                     status: "error",
        //                     duration: 9000,
        //                     isClosable: true,
        //                 })
        //             }
        //             else {
        //                 addDocumentInStorage({
        //                     id: response.data.file_id,
        //                     name: response.data.filename,
        //                     url: response.data.url,
        //                     thumbnail: response.thumbnail_presigned_url,
        //                     highlights: [],
        //                     messages: [],
        //                     messagesGeneration: [],
        //                 })
        //                 auth.setPlaygroundDocuments(getDocumentsInStorage());
        //                 dispatch(addVideo({
        //                     id: response.data.file_id,
        //                     name: response.data.filename,
        //                     url: response.data.url,
        //                     thumbnail_url: response.thumbnail_presigned_url,
        //                     highlights: [],
        //                     messages: [],
        //                     messagesGeneration: [],
        //                 }));
        //                 toast({
        //                     title: t("Video uploaded."),
        //                     status: "success",
        //                     duration: 9000,
        //                     isClosable: true,
        //                 })
        //             }
        //
        //         } catch (error) {
        //             dispatch(setIsUploadLoading(false));
        //             setUploadProgress(0);
        //             toast({
        //                 title: t("Oops, this PDF failed."),
        //                 description: t("Please try again or upload a different PDF."),
        //                 status: "error",
        //                 duration: 9000,
        //                 isClosable: true,
        //             })
        //             console.error('Error uploading the document:', error);
        //         }
        // }
    }

    // Select the correct document list based on authentication
    const documents = useSelector(state => state.documents.savedDocuments);
    const videos = useSelector(state => state.documents.savedVideos);
    const generations = useSelector(state => state.documents.savedGenerations);
    const audiobooks = useSelector(state => state.documents.savedAudiobooks);

    // CHANGE THIS FOR VIDEOS LATER
    useEffect(() => {
        const tempUserID = localStorage.getItem("userID");

        if (tempUserID !== null) {
            // Get the current search parameters
            // const currentSearchParams = new URLSearchParams(window.location.search);
            // const currentTab = currentSearchParams.get('tab');

            // // Decide navigation based on the user's entered path or default
            // if (currentTab === 'videos') {
            //     navigate('/?tab=videos'); // Stay on videos
            //     setTabIndex(2);
            // } else if (currentTab === 'multidoc') {
            //     navigate('/?tab=multidoc'); // Stay on multidocs
            //     setTabIndex(1);
            // } else if (currentTab === 'pdfs' || currentTab === null) {
            //     // Default to PDFs if no `tab` query or explicitly `tab=pdfs`
            //     navigate('/?tab=pdfs');
            //     setTabIndex(0);
            // }

            // Fetch documents and videos
            fetchDocuments(tempUserID, serverIPs.SERVER_IP).then(r => {
                dispatch(setDocuments(r.documents));
            });
            fetchVideos(tempUserID, serverIPs.SERVER_IP_VIDEO).then(r => {
                dispatch(setVideos(r.videos));
            });
            fetchMultidocs(tempUserID, serverIPs.SERVER_IP_MULTIDOC).then(r => {
                dispatch(setDocumentsGeneration(r.multidocs));
            });
            fetchAudiobooks(tempUserID, serverIPs.SERVER_IP).then(r => {
                dispatch(setAudiobooks(r.audiobooks));
            });
        }
    }, []);


    const placeholders = ["https://www.youtube.com/watch?v=aJwdWeiSc8c",
        "https://www.youtube.com/watch?v=nyOD7m4uOv8"];
    const [currentPlaceholder, setCurrentPlaceholder] = useState(placeholders[0]);
    const [index, setIndex] = useState(0);
    const [fade, setFade] = useState(true); // State to manage fade in and out
    const [urlInput, setUrlInput] = useState("");

    useEffect(() => {
        const intervalId = setInterval(() => {
            setFade(false); // Fade out the current placeholder

            setTimeout(() => {
                // After fade out, change the placeholder and fade it in
                setIndex((prevIndex) => (prevIndex + 1) % placeholders.length);
                setCurrentPlaceholder(placeholders[index]);
                setFade(true);
            }, 750); // Half the interval time to allow for fade in and fade out
        }, 1500);

        return () => clearInterval(intervalId);
    }, [index]);

    const handleSubmit = () => {
        if (!auth.isLoggedIn) {
            toast({
                title: "Please sign up to upload YouTube videos",
                description: "Then you can chat with them just like with normal PDFs!",
                status: "info",
                duration: 9000,
                isClosable: true,
                position: "top",
            });
            onOpenSignUpScreen1();
        } else {
            setUrlInput("");
            handleYoutubeLinkUpload(urlInput).then(r => {
                setUrlInput("")
                // navigate('/?tab=videos');
            });
        }
    };

    const [tabIndex, setTabIndex] = useState(0);
    const [workspaceLoading, setWorkspaceLoading] = useState(false);
    const areAllFilesEmpty = (...fileArrays) => {
        return fileArrays.every(fileArray => fileArray.length === 0) && !auth.isLoggedIn;
    };

    const isAnyFileNonEmpty = (...fileArrays) => {
        return fileArrays.some(fileArray => fileArray.length !== 0);
    };

    const renderTabContent = () => {
        if (tabIndex === 0) {
            return documents.length !== 0 ? (
                <DocumentGrid navigate={navigate} />
            ) : (
                <DocumentGridEmpty />
            );
        }

        if (tabIndex === 1) {
            return generations.length !== 0 ? (
                <DocumentGridGeneration navigate={navigate} />
            ) : (
                <DocumentGridGenerationEmpty />
            );
        }

        if (tabIndex === 2) {
            return videos.length !== 0 ? (
                <DocumentGridVideos navigate={navigate} />
            ) : (
                <DocumentGridVideosEmpty />
            );
        }

        if (tabIndex === 4) {
            return videos.length !== 0 ? (
                <DocumentGridMembers navigate={navigate} />
            ) : (
                <DocumentGridMembersEmpty />
            );
        }

        if (tabIndex === 5) {
            return videos.length !== 0 ? (
                <DocumentGridMembers navigate={navigate} />
            ) : (
                <DocumentGridMembersEmpty />
            );
        }

        if (tabIndex === 3) {
            return audiobooks.length !== 0 ? (
                <DocumentGridAudiobooks navigate={navigate} />
            ) : (
                <DocumentGridAudiobooksEmpty />
            );
        }

        return null; // Default case if tabIndex is not 0, 1, or 2
    };

    const phrases = [
        "What is the main argument of this document? Respond in Spanish.",
        "Give a detailed summary of the entire document.",
        "Which quotes are most relevant in supporting my thesis statement?"
    ];

    return (
        <div>
            <FullScreenTemplateHomePage navigateToTestimonials={navigateToTestimonials} navigateToFeatures={navigateToFeatures}>
                <VStack width={'100%'} height={'100%'} justifyContent={'center'} display={'flex'} spacing={'4rem'}
                        mt={areAllFilesEmpty(documents, videos, generations, audiobooks) ? '0rem' : '0rem'}>
                    {isAnyFileNonEmpty(documents, videos, generations, audiobooks) || auth.isLoggedIn ?
                        isUploadLoading ?
                            <Box width={'60%'} pt={'3.5rem'}>
                                <LoadingBar progress={uploadProgress} isMarginBottom={true}/>
                            </Box> :
                            <VStack width={"100%"} height={'21.75rem'} mb={'1rem'} spacing={6} py={'1.75rem'}
                                    bg={lightTheme.colors.lightGray}>
                                <VStack
                                    width={{
                                        base: '88%',
                                        sm: '70%',
                                        md: '60%',
                                        lg: '55%',
                                        xl: '50%',
                                    }}
                                    bg={'white'}
                                    height={'18rem'}
                                    borderRadius={'15px'}
                                    spacing={4}
                                    borderColor={'lightgray'}
                                    borderWidth={0.25}
                                    shadow={`1.5px 1.8px 0px lightgray`}
                                    position="relative"
                                >
                                    <Tabs
                                        variant="soft-rounded"
                                        colorScheme="orange"
                                        onChange={handleTabChange}
                                        index={tabIndex}
                                        width="100%"
                                        position="absolute"
                                        top="0rem"
                                        left="0rem"
                                        zIndex={1}
                                    >
                                        <TabList>
                                            <Tab borderTopLeftRadius={'15px'}
                                                 borderTopRightRadius={'0px'}
                                                 borderBottomRadius={'0px'}
                                                 borderBottomWidth={'0.25px'}
                                                 borderBottomColor={'orange.100'}
                                                 sx={{
                                                     color: 'gray.600', // Default color
                                                     _selected: {
                                                         color: 'black', // Color when selected
                                                         bg: 'orange.100', // Background color when selected
                                                     },
                                                 }}
                                                 fontSize={!isMobile ? 15 : 13}>Single-Upload</Tab>
                                            <Tab borderRadius={'0px'} sx={{
                                                color: 'gray.600', // Default color
                                                _selected: {
                                                    color: 'black', // Color when selected
                                                    bg: 'orange.100', // Background color when selected
                                                },
                                            }} borderRightWidth={'0.25px'}
                                                 borderRightColor={'orange.100'}
                                                // borderLeftWidth={'0.25px'}
                                                // borderLeftColor={'orange.100'}
                                                 borderBottomWidth={'0.25px'}
                                                 borderBottomColor={'orange.100'}
                                                 fontSize={!isMobile ? 15 : 13}>
                                                <Box display="flex" alignItems="center">
                                                    Multi-Upload
                                                    {/*<Badge*/}
                                                    {/*    colorScheme="purple"*/}
                                                    {/*    variant="solid"*/}
                                                    {/*    ml="3" // Adjust this margin to control spacing between text and badge*/}
                                                    {/*    fontSize="0.7em"*/}
                                                    {/*    borderRadius="5"*/}
                                                    {/*    px="2"*/}
                                                    {/*    py="1"*/}
                                                    {/*    boxShadow="0px 1px 6px -1px rgba(0, 0, 0, 0.1), 0px 1px 6px -1px rgba(0, 0, 0, 0.1)"*/}
                                                    {/*>*/}
                                                    {/*    NEW*/}
                                                    {/*</Badge>*/}
                                                </Box>
                                            </Tab>
                                            <Tab borderRadius={'0px'} sx={{
                                                color: 'gray.600', // Default color
                                                _selected: {
                                                    color: 'black', // Color when selected
                                                    bg: 'orange.100', // Background color when selected
                                                },
                                            }} borderRightWidth={'0.25px'}
                                                 borderRightColor={'orange.100'}
                                                // borderLeftWidth={'0.25px'}
                                                // borderLeftColor={'orange.100'}
                                                 borderBottomWidth={'0.25px'}
                                                 borderBottomColor={'orange.100'}
                                                 fontSize={!isMobile ? 15 : 13}>
                                                <Box display="flex" alignItems="center">
                                                    Videos/MP3
                                                    {/* <Badge
                                                        colorScheme="purple"
                                                        variant="solid"
                                                        ml="3" // Adjust this margin to control spacing between text and badge
                                                        fontSize="0.7em"
                                                        borderRadius="5"
                                                        px="2"
                                                        py="1"
                                                        boxShadow="0px 1px 6px -1px rgba(0, 0, 0, 0.1), 0px 1px 6px -1px rgba(0, 0, 0, 0.1)"
                                                    >
                                                        NEW
                                                    </Badge> */}
                                                    {/*<Badge*/}
                                                    {/*    colorScheme="purple"*/}
                                                    {/*    variant="solid"*/}
                                                    {/*    ml="3" // Adjust this margin to control spacing between text and badge*/}
                                                    {/*    fontSize="0.7em"*/}
                                                    {/*    borderRadius="5"*/}
                                                    {/*    px="2"*/}
                                                    {/*    py="1"*/}
                                                    {/*    boxShadow="0px 1px 6px -1px rgba(0, 0, 0, 0.1), 0px 1px 6px -1px rgba(0, 0, 0, 0.1)"*/}
                                                    {/*>*/}
                                                    {/*    NEW*/}
                                                    {/*</Badge>*/}
                                                </Box>
                                            </Tab>
                                            <Tab borderRadius={'0px'} sx={{
                                                color: 'gray.600', // Default color
                                                _selected: {
                                                    color: 'black', // Color when selected
                                                    bg: 'orange.100', // Background color when selected
                                                },
                                            }} borderRightWidth={'0.25px'}
                                                 borderRightColor={'orange.100'}
                                                 borderLeftWidth={'0.25px'}
                                                 borderLeftColor={'orange.100'}
                                                 borderBottomWidth={'0.25px'}
                                                 borderBottomColor={'orange.100'}
                                                 fontSize={!isMobile ? 15 : 13}>
                                                <Box display="flex" alignItems="center" flexDirection={!isMobile ? 'row' : 'column'}>
                                                    Audiobooks
                                                </Box>
                                            </Tab>
                                            {/*<Tab borderRadius={'0px'} sx={{*/}
                                            {/*    color: 'gray.600', // Default color*/}
                                            {/*    _selected: {*/}
                                            {/*        color: 'black', // Color when selected*/}
                                            {/*        bg: 'orange.100', // Background color when selected*/}
                                            {/*    },*/}
                                            {/*}} borderRightWidth={'0.25px'}*/}
                                            {/*     borderRightColor={'orange.100'}*/}
                                            {/*     borderBottomWidth={'0.25px'}*/}
                                            {/*     borderBottomColor={'orange.100'}*/}
                                            {/*     fontSize={!isMobile ? 15 : 13}>*/}
                                            {/*    <Box display="flex" alignItems="center">*/}
                                            {/*        Members*/}
                                            {/*    </Box>*/}
                                            {/*</Tab>*/}
                                            {/*<Tab borderRadius={'0px'} sx={{*/}
                                            {/*    color: 'gray.600', // Default color*/}
                                            {/*    _selected: {*/}
                                            {/*        color: 'black', // Color when selected*/}
                                            {/*        bg: 'orange.100', // Background color when selected*/}
                                            {/*    },*/}
                                            {/*}} borderRightWidth={'0.25px'}*/}
                                            {/*     borderRightColor={'orange.100'}*/}
                                            {/*     borderBottomWidth={'0.25px'}*/}
                                            {/*     borderBottomColor={'orange.100'}*/}
                                            {/*     fontSize={!isMobile ? 15 : 13}>*/}
                                            {/*    <Box display="flex" alignItems="center">*/}
                                            {/*        BigQuery*/}
                                            {/*    </Box>*/}
                                            {/*</Tab>*/}
                                        </TabList>

                                        <TabPanels px={2.5}>
                                            <TabPanel>
                                                {/* PDF Upload UI */}
                                                <MotionBox
                                                    {...getRootProps()}
                                                    border="2px"
                                                    borderColor="orange.400"
                                                    borderRadius="md"
                                                    borderStyle="dashed"
                                                    textAlign="center"
                                                    p="3"
                                                    mt={4}
                                                    pt={'1.05rem'}
                                                    cursor="pointer"
                                                    _hover={{ bg: 'gray.100' }}
                                                    animate={isDragActive ? { scale: 1.05 } : { scale: 1 }}
                                                    transition={{ duration: 0.2 }}
                                                    width="100%"
                                                    height="9rem"
                                                    onClick={() => {
                                                        if (getDocumentsInStorage().length === 1 && !auth.isLoggedIn) {
                                                            toast({
                                                                title: t("You've reached your document limit in guest mode!"),
                                                                description: t("Please sign up to continue uploading documents."),
                                                                status: "info",
                                                                duration: 9000,
                                                                isClosable: true,
                                                                position: "top",
                                                            });
                                                            onOpenSignUpScreen1();
                                                        }
                                                        else if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
                                                            toast({
                                                                title: t("(Free Plan) PDF Upload Limit Exceeded!"),
                                                                status: "info",
                                                                duration: 9000,
                                                                isClosable: true,
                                                                position: "top",
                                                            });
                                                            dispatch(setIsPricingModalOpen(true));
                                                        }
                                                        else {
                                                            fileInput.current.click();
                                                        }
                                                    }}
                                                >
                                                    <input {...getInputProps()} ref={fileInput}/>
                                                    <Box as="span" color="gray.400" fontSize="3xl">
                                                        ⇧
                                                    </Box>
                                                    <Text fontWeight="bold" color="gray.400" fontSize={15}>
                                                        {t("Drag & Drop")}
                                                    </Text>
                                                    <Text color="gray.500" fontSize={15}>{t("or click to browse")}</Text>
                                                </MotionBox>
                                            </TabPanel>

                                            {/*Multi-PDF Upload UI*/}
                                            <TabPanel>
                                                <VStack>
                                                    {auth.isLoggedIn ?
                                                        <Text fontSize={17} color={'black'} mt={7} mb={8} fontWeight="500" textAlign={'center'}>
                                                            Chat with multiple files at the same time!
                                                        </Text> :
                                                        <Text fontSize={17} color={'black'} mt={7} mb={12} fontWeight="500" textAlign={'center'}>
                                                            Please sign up to chat with multiple files at the same time!
                                                        </Text>
                                                    }

                                                    <Button
                                                        borderRadius={12}
                                                        isLoading={workspaceLoading}
                                                        px={6}
                                                        py={6}
                                                        fontSize={18}
                                                        colorScheme={'orange'}
                                                        bgGradient="linear(to-r, orange.400, orange.500)"
                                                        _hover={{
                                                            bgGradient: "linear(to-r, orange.400, orange.600)", // Adjusts the gradient on hover
                                                            boxShadow: 'lg' // Adds a slight shadow on hover
                                                        }}
                                                        onClick={() => {
                                                            if (!auth.isLoggedIn) {
                                                                toast({
                                                                    title: "Please sign up to upload multiple files",
                                                                    description: "Then you can chat with all of them at the same time!",
                                                                    status: "info",
                                                                    duration: 9000,
                                                                    isClosable: true,
                                                                    position: "top",
                                                                });
                                                                onOpenSignUpScreen1();
                                                            } else {
                                                                setWorkspaceLoading(true);
                                                                const userID = auth.isLoggedIn ? localStorage.getItem("userID") : "11111111-1111-1111-1111-111111111111"
                                                                initializeMultidoc("Untitled Workspace", userID, serverIPs.SERVER_IP_MULTIDOC).then(r => {
                                                                    setWorkspaceLoading(false);
                                                                    navigate(`/multidoc/${r.id}`)
                                                                    window.location.reload();
                                                                    console.log("initialize multidoc here", r)
                                                                });
                                                            }

                                                        }}>
                                                        Create new Workspace
                                                    </Button>
                                                </VStack>
                                            </TabPanel>
                                            {/*Multi-PDF Upload UI*/}


                                            <TabPanel>
                                                {auth.isLoggedIn ?
                                                    <Text fontSize={!isMobile ? 17 : 15} color={'black'} mt={!isMobile ? 7 : 3} mb={6} fontWeight="500" textAlign={'center'}>
                                                        Enter a YouTube link below or upload an mp4/mp3 file
                                                    </Text> :
                                                    <Text fontSize={!isMobile ? 17 : 15} color={'black'} mt={!isMobile ? 7 : 3} mb={6} fontWeight="500" textAlign={'center'}>
                                                        Please sign up to use this feature!
                                                    </Text>
                                                }

                                                <Box mb={6} textAlign="center">
                                                    <Button
                                                        borderRadius={12}
                                                        px={6}
                                                        py={6}
                                                        fontSize={!isMobile ? 16 : 14}
                                                        colorScheme="orange"
                                                        onClick={() => {
                                                            if (!auth.isLoggedIn) {
                                                                toast({
                                                                    title: "Please sign up to upload mp4 or mp3 files",
                                                                    description: "Then you can chat with them just like with normal PDFs!",
                                                                    status: "info",
                                                                    duration: 9000,
                                                                    isClosable: true,
                                                                    position: "top",
                                                                });
                                                                onOpenSignUpScreen1();
                                                            } else {
                                                                fileInputVideo.current.click()
                                                            }
                                                        }}
                                                    >
                                                        Upload mp4 or mp3 File
                                                    </Button>
                                                    <input
                                                        type="file"
                                                        accept="video/*,audio/*"
                                                        onChange={handleMP4Upload}
                                                        ref={fileInputVideo}
                                                        style={{ display: "none" }}
                                                    />
                                                </Box>
                                                <URLInput
                                                    urlInput={urlInput}
                                                    setUrlInput={setUrlInput}
                                                    handleSubmit={handleSubmit}
                                                    currentPlaceholder={currentPlaceholder}
                                                    fade={fade}
                                                />
                                            </TabPanel>

                                            <TabPanel>
                                                {/*Audiobook Upload UI*/}
                                                <MotionBox
                                                    {...getRootPropsAudiobook()}
                                                    border="2px"
                                                    borderColor="orange.400"
                                                    borderRadius="md"
                                                    borderStyle="dashed"
                                                    textAlign="center"
                                                    p="3"
                                                    mt={4}
                                                    pt={'1.05rem'}
                                                    cursor="pointer"
                                                    _hover={{ bg: 'gray.100' }}
                                                    animate={isDragActiveAudiobook ? { scale: 1.05 } : { scale: 1 }}
                                                    transition={{ duration: 0.2 }}
                                                    width="100%"
                                                    height="9rem"
                                                    onClick={() => {
                                                        if (!auth.isLoggedIn) {
                                                            toast({
                                                                title: "Please sign up to create audiobooks",
                                                                description: "Listen 2x faster, and get a better understanding of your documents!",
                                                                status: "info",
                                                                duration: 9000,
                                                                isClosable: true,
                                                                position: "top",
                                                            });
                                                            onOpenSignUpScreen1();
                                                        }
                                                        else {
                                                            fileInputAudiobook.current.click();
                                                        }
                                                    }}
                                                >
                                                    <input {...getInputPropsAudiobook({ accept: 'application/pdf' })} ref={fileInputAudiobook}/>
                                                    <Box as="span" color="gray.400" fontSize="3xl">
                                                        ⇧
                                                    </Box>
                                                    <Text fontWeight="bold" color="gray.400" fontSize={15}>
                                                        {t("Drag & Drop")}
                                                    </Text>
                                                    <Text color="gray.500" fontSize={15}>{t("or click to browse")}</Text>
                                                </MotionBox>
                                            </TabPanel>


                                            <TabPanel>
                                                <VStack>
                                                    {auth.isLoggedIn ?
                                                        <Text fontSize={17} color={'black'} mt={7} mb={8} fontWeight="500" textAlign={'center'}>
                                                            Chat with Multiple Files at the same time!
                                                        </Text> :
                                                        <Text fontSize={17} color={'black'} mt={7} mb={12} fontWeight="500" textAlign={'center'}>
                                                            Please sign up to chat with multiple files at the same time.
                                                        </Text>
                                                    }

                                                    <Button
                                                        borderRadius={12}
                                                        isLoading={workspaceLoading}
                                                        px={6}
                                                        py={6}
                                                        fontSize={18}
                                                        colorScheme={'orange'}
                                                        bgGradient="linear(to-r, orange.400, orange.500)"
                                                        _hover={{
                                                            bgGradient: "linear(to-r, orange.400, orange.600)", // Adjusts the gradient on hover
                                                            boxShadow: 'lg' // Adds a slight shadow on hover
                                                        }}
                                                        onClick={() => {
                                                            if (!auth.isLoggedIn) {
                                                                toast({
                                                                    title: "Please sign up to upload multiple files",
                                                                    description: "Then you can chat with all of them at the same time!",
                                                                    status: "info",
                                                                    duration: 9000,
                                                                    isClosable: true,
                                                                    position: "top",
                                                                });
                                                                onOpenSignUpScreen1();
                                                            } else {
                                                                setWorkspaceLoading(true);
                                                                const userID = auth.isLoggedIn ? localStorage.getItem("userID") : "11111111-1111-1111-1111-111111111111"
                                                                initializeMultidoc("Untitled Workspace", userID, serverIPs.SERVER_IP_MULTIDOC).then(r => {
                                                                    setWorkspaceLoading(false);
                                                                    navigate(`/multidoc/${r.id}`)
                                                                    window.location.reload();
                                                                    console.log("initialize multidoc here", r)
                                                                });
                                                            }

                                                        }}>
                                                        Create new Workspace
                                                    </Button>
                                                </VStack>
                                            </TabPanel>


                                            <TabPanel>
                                                <VStack>
                                                    {auth.isLoggedIn ?
                                                        <Text fontSize={17} color={'black'} mt={7} mb={8} fontWeight="500" textAlign={'center'}>
                                                            Search and Chat with your entire database
                                                        </Text> :
                                                        <Text fontSize={17} color={'black'} mt={7} mb={12} fontWeight="500" textAlign={'center'}>
                                                            Please sign up to search and chat with your entire database
                                                        </Text>
                                                    }

                                                    <Button
                                                        borderRadius={12}
                                                        isLoading={workspaceLoading}
                                                        px={6}
                                                        py={6}
                                                        fontSize={18}
                                                        colorScheme={'orange'}
                                                        bgGradient="linear(to-r, orange.400, orange.500)"
                                                        _hover={{
                                                            bgGradient: "linear(to-r, orange.400, orange.600)", // Adjusts the gradient on hover
                                                            boxShadow: 'lg' // Adds a slight shadow on hover
                                                        }}
                                                        onClick={() => {
                                                            setWorkspaceLoading(true);
                                                            if (!auth.isLoggedIn) {
                                                                toast({
                                                                    title: "Please sign up",
                                                                    description: "Please sign up to search and chat with your entire database",
                                                                    status: "info",
                                                                    duration: 9000,
                                                                    isClosable: true,
                                                                    position: "top",
                                                                });
                                                                onOpenSignUpScreen1();
                                                            } else {
                                                                const userID = auth.isLoggedIn ? localStorage.getItem("userID") : "11111111-1111-1111-1111-111111111111"
                                                                initializeMultidoc("Untitled Workspace", userID, serverIPs.SERVER_IP_MULTIDOC).then(r => {
                                                                    setWorkspaceLoading(false);
                                                                    navigate(`/multidoc2/${r.id}`)
                                                                    window.location.reload();
                                                                    console.log("initialize multidoc here", r)
                                                                });
                                                            }

                                                        }}>
                                                        Create new Workspace
                                                    </Button>
                                                </VStack>
                                            </TabPanel>


                                        </TabPanels>
                                    </Tabs>
                                </VStack>
                            </VStack>
                        : null}

                    {
                        areAllFilesEmpty(documents, videos, generations, audiobooks) ? (
                            <Box bg="white" minH="100vh" overflowX="hidden">
                                {/* Hero Section - White Background */}
                                {/*<Box*/}
                                {/*    bgGradient="linear(to-b, white 0%, #f8fafc 20%, #f1f8ff 60%, #f0f8fe 100%)"*/}
                                {/*    pb={16}*/}
                                {/*    mt={0}*/}
                                {/*>*/}

                                {/*</Box>*/}
                                <Box
                                    bgGradient="linear(to-b, white 0%, #f8fafc 20%, #f1f8ff 60%, #f0f8fe 100%)"
                                    width="100vw"
                                    position="relative"
                                    pt={16}
                                    pb={20}
                                >
                                    <Container maxW="6xl">
                                        <VStack textAlign="center">
                                            <VStack spacing={6}>
                                                <Heading
                                                    fontSize={{ base: '5xl', md: '6xl', lg: '7xl' }}
                                                    fontWeight="700"
                                                    color="#1e293b"
                                                    mt={!isMobile ? 0 : -1}
                                                    lineHeight="1.05"
                                                    letterSpacing="-0.025em"
                                                >
                                                    Hamlet Summary
                                                </Heading>
                                            </VStack>
                                        </VStack>
                                    </Container>
                                </Box>

                                <VStack spacing={14} mt={0}>
                                    <Text
                                        fontSize={{ base: 'md', md: 'lg' }}
                                        color="#64748b"
                                        maxW="4xl"
                                        lineHeight="1.6"
                                        mt={16}
                                        ml={4}
                                    >
                                        Hamlet, Prince of Denmark, is devastated by his father's sudden death and his mother Gertrude's hasty marriage 
                                        to his uncle Claudius, who has assumed the throne. When his father's ghost reveals that Claudius murdered him
                                        by pouring poison in his ear, Hamlet vows revenge but struggles with doubt and indecision. To confirm Claudius's
                                        guilt, Hamlet stages a play mirroring the murder, which provokes Claudius's guilty reaction. Feigning madness to
                                        investigate further, Hamlet accidentally kills Polonius, the court advisor, while confronting his mother. This 
                                        drives Polonius's daughter Ophelia, whom Hamlet loves, to madness and drowning. Polonius's son Laertes returns
                                        seeking vengeance. Claudius arranges a duel between Hamlet and Laertes using poisoned swords and wine. The plan
                                        backfires catastrophically: Gertrude drinks the poisoned wine, both Hamlet and Laertes are wounded by the poisoned 
                                        sword, and Hamlet finally kills Claudius. As Hamlet dies, he names Prince Fortinbras of Norway as Denmark's next king,
                                        bringing the tragic cycle to its close.
                                    </Text>
                                    <Button
                                        borderRadius={16}
                                        px={isMobile ? 6 : 7}
                                        py={isMobile ? 6 : 7}
                                        fontSize={isMobile ? 18 : 22}
                                        colorScheme={'orange'}
                                        bgGradient="linear(to-r, orange.400, orange.500)"
                                        _hover={{
                                            bgGradient: "linear(to-r, orange.400, orange.600)", // Adjusts the gradient on hover
                                            boxShadow: 'lg' // Adds a slight shadow on hover
                                        }}
                                        onClick={() => {
                                            window.open('https://www.gutenberg.org/ebooks/1524', '_blank');
                                        }}>
                                        Download Book PDF
                                    </Button>
                                    {/*<Text color="#64748b" fontSize="sm" fontWeight={500}>No credit card required.</Text>*/}
                                </VStack>



                                {/* How It Works - Back to White Background */}
                                <Box bg="white" pb={20} pt={24}>
                                    <Container maxW="7xl">
                                        <VStack spacing={4}>
                                            <Heading size="2xl" textAlign="center" color="#1e293b" fontWeight="bold">
                                                AI Book Reader:
                                            </Heading>
                                            <Heading size="2xl" textAlign="center" color="#1e293b" mb={14} fontWeight="bold">
                                                Get A Detailed Summary of Each Chapter
                                            </Heading>
                                        </VStack>

                                        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={{ base: 4, md: 8 }}>
                                            {/* Step 1: Upload */}
                                            <Box
                                                p={{ base: 4, md: 8 }}
                                                bg="#f1f5f9"
                                                borderRadius="xl"
                                                textAlign="center"
                                                border="1px"
                                                borderColor="#e2e8f0"
                                                display="flex"
                                                flexDirection="column"
                                                h="100%"
                                                gridColumn={{ base: "auto", md: "span 2", lg: "auto" }}
                                            >
                                                <Box
                                                    w="full"
                                                    borderRadius="lg"
                                                    border="1px"
                                                    borderColor="#e2e8f0"
                                                    overflow="hidden"
                                                    flex="1"
                                                    mb={{ base: 4, md: 6 }}
                                                >
                                                    <Image
                                                        src={process.env.PUBLIC_URL + "/HB_newlandingpage7.jpg"}
                                                        alt="Generate Summaries Feature"
                                                        width="100%"
                                                        height="100%"
                                                        objectFit="cover"
                                                        borderRadius="lg"
                                                    />
                                                </Box>
                                                <VStack spacing={{ base: 2, md: 4 }}>
                                                    <Text fontSize={{ base: "lg", md: "xl" }} fontWeight="bold" color="#1e293b">1) Upload</Text>
                                                    <Text color="#64748b" textAlign="center" fontSize={{ base: "sm", md: "md" }}>
                                                        Upload any document or book
                                                    </Text>
                                                </VStack>
                                            </Box>

                                            {/* Step 2: Ask Questions */}
                                            <Box
                                                p={{ base: 4, md: 8 }}
                                                bg="#f1f5f9"
                                                borderRadius="xl"
                                                textAlign="center"
                                                border="1px"
                                                borderColor="#e2e8f0"
                                                display="flex"
                                                flexDirection="column"
                                                h="100%"
                                            >
                                                <Box
                                                    w="full"
                                                    bg="white"
                                                    borderRadius="lg"
                                                    p={{ base: 3, md: 4 }}
                                                    border="1px"
                                                    borderColor="#e2e8f0"
                                                    flex="1"
                                                    mb={{ base: 4, md: 6 }}
                                                >
                                                    <VStack spacing={3} w="full">
                                                        <Box w="full" p={3} bg="#eff6ff" borderRadius="lg" border="1px" borderColor="#bfdbfe">
                                                            <Text fontSize={{ base: "xs", md: "xs" }} color="#1e293b" textAlign="left">
                                                                Please give a detailed summary of pages 35-96.
                                                            </Text>
                                                        </Box>
                                                        <Box w="full" p={3} bg="white" borderRadius="lg" border="1px" borderColor="#e2e8f0">
                                                            <Text fontSize={{ base: "xs", md: "xs" }} color="#64748b" textAlign="left">
                                                                Create 30 difficult multiple-choice questions based on Chapter 7 of the book.
                                                            </Text>
                                                        </Box>
                                                        <Box w="full" p={3} bg="white" borderRadius="lg" border="1px" borderColor="#e2e8f0">
                                                            <Text fontSize={{ base: "xs", md: "xs" }} color="#64748b" textAlign="left">
                                                                Which quotes in the book are most relevant in supporting my essay's thesis?
                                                            </Text>
                                                        </Box>
                                                    </VStack>
                                                </Box>
                                                <VStack spacing={{ base: 2, md: 4 }}>
                                                    <Text fontSize={{ base: "lg", md: "xl" }} fontWeight="bold" color="#1e293b">2) Ask Any Questions</Text>
                                                    <Text color="#64748b" textAlign="center" fontSize={{ base: "sm", md: "md" }}>
                                                        Say a page range and get answers
                                                    </Text>
                                                </VStack>
                                            </Box>

                                            {/* Step 3: Get Answers */}
                                            <Box
                                                p={{ base: 4, md: 8 }}
                                                bg="#f1f5f9"
                                                borderRadius="xl"
                                                textAlign="center"
                                                border="1px"
                                                borderColor="#e2e8f0"
                                                display="flex"
                                                flexDirection="column"
                                                h="100%"
                                            >
                                                <Box
                                                    w="full"
                                                    bg="white"
                                                    borderRadius="lg"
                                                    p={{ base: 3, md: 4 }}
                                                    border="1px"
                                                    borderColor="#e2e8f0"
                                                    flex="1"
                                                    mb={{ base: 4, md: 6 }}
                                                >
                                                    <VStack spacing={3} align="start" w="full">
                                                        <Text fontSize={{ base: "sm", md: "sm" }} color="orange.700" fontWeight="bold">
                                                            Detailed summary of Chapter 7?
                                                        </Text>
                                                        <Text
                                                            fontSize={{ base: "xs", md: "xs" }}
                                                            color="#1e293b"
                                                            lineHeight="1.5"
                                                            textAlign="left"
                                                        >
                                                            The boys decide to keep a signal fire on the mountain, lighting
                                                            it with Piggy’s glasses. Excitement turns to chaos as the blaze rages out of control. A littlun with a mulberry birthmark,
                                                            who had spoken of a “beastie,” goes missing, likely dead. Piggy, ignored and mocked, condemns their carelessness.
                                                            The chapter marks the group’s slide from order toward danger. Jack’s hunters reveal rashness, while Ralph’s authority starts to fray.
                                                        </Text>
                                                    </VStack>
                                                </Box>
                                                <VStack spacing={{ base: 2, md: 4 }}>
                                                    <Text fontSize={{ base: "lg", md: "xl" }} fontWeight="bold" color="#1e293b">3) Get Answers</Text>
                                                    <Text color="#64748b" textAlign="center" fontSize={{ base: "sm", md: "md" }}>
                                                        Get high-quality responses that are accurate, reliable, and highly detailed.
                                                    </Text>
                                                </VStack>
                                            </Box>
                                        </SimpleGrid>
                                        <VStack justifyContent={'center'} mt={'5rem'}>
                                            <Button
                                                borderRadius={16}
                                                px={isMobile ? 6 : 7}
                                                py={isMobile ? 6 : 7}
                                                fontSize={isMobile ? 18 : 22}
                                                colorScheme={'orange'}
                                                bgGradient="linear(to-r, orange.400, orange.500)"
                                                _hover={{
                                                    bgGradient: "linear(to-r, orange.400, orange.600)", // Adjusts the gradient on hover
                                                    boxShadow: 'lg' // Adds a slight shadow on hover
                                                }}
                                                onClick={() => {
                                                    onOpenSignUpScreen1();
                                                }}>
                                                Get Detailed Summary
                                            </Button>
                                        </VStack>
                                    </Container>
                                </Box>

                                {/* Bottom CTA - Dark Blue */}
                                <Box bg="#1e293b" py={16}>
                                    <Container maxW="4xl" textAlign="center">
                                        <VStack spacing={6}>
                                            <Text color="#94a3b8" textTransform="uppercase" letterSpacing="wide" fontSize="sm" fontWeight="medium">
                                                READ BOOKS FASTER
                                            </Text>
                                            <Heading size="2xl" color="white" fontWeight="bold">
                                                Summarize a book in seconds.
                                            </Heading>
                                            <Text color="lightgray" fontSize="lg" maxW="2xl" fontWeight={500}>
                                                29% of users in a recent survey reported that Honeybear.ai saves them 9-14 hours every week.
                                            </Text>
                                            <Button
                                                borderRadius={16}
                                                px={isMobile ? 6 : 7}
                                                py={isMobile ? 6 : 7}
                                                fontSize={isMobile ? 18 : 22}
                                                colorScheme={'orange'}
                                                bgGradient="linear(to-r, orange.400, orange.500)"
                                                _hover={{
                                                    bgGradient: "linear(to-r, orange.400, orange.600)", // Adjusts the gradient on hover
                                                    boxShadow: 'lg' // Adds a slight shadow on hover
                                                }}
                                                onClick={() => {
                                                    if (auth.isLoggedIn) {
                                                        fileInput.current.click();
                                                    } else {
                                                        onOpenSignUpScreen1();
                                                    }
                                                }}>
                                                Try for Free
                                            </Button>
                                            {/*<Button*/}
                                            {/*    bg="white"*/}
                                            {/*    color="#1e293b"*/}
                                            {/*    size="lg"*/}
                                            {/*    px={8}*/}
                                            {/*    py={6}*/}
                                            {/*    fontSize="lg"*/}
                                            {/*    borderRadius="lg"*/}
                                            {/*    _hover={{ bg: "#f8fafc" }}*/}
                                            {/*    fontWeight="600"*/}
                                            {/*>*/}
                                            {/*    Start for Free*/}
                                            {/*</Button>*/}
                                        </VStack>
                                    </Container>
                                </Box>

                                {/* Footer - White */}
                                {/*<LargeWithNewsletter />*/}
                            </Box>
                        ) : (
                            renderTabContent()
                        )
                    }
                </VStack>
            </FullScreenTemplateHomePage>
            <Box height={"8rem"}/>
            {auth.isLoggedIn ?
                <LargeWithNewsletter/> : <LargeWithNewsletter backColor="white"/>}
            <SignUpScreen1 isOpenSignUpScreen1={isOpenSignUpScreen1} onCloseSignUpScreen1={onCloseSignUpScreen1} onOpenSignInScreen1={onOpenSignInScreen1}/>
            <SignInScreen1 isOpenSignInScreen1={isOpenSignInScreen1} onCloseSignInScreen1={onCloseSignInScreen1} onOpenSignUpScreen1={onOpenSignUpScreen1}/>
            <ScanModal1 isOpenScanModal1={isOpenScanModal1} onCloseScanModal1={onCloseScanModal1} onOpenScanModal1={onOpenScanModal1}/>
            <ScanModalIntro1 isOpenScanModalIntro1={isOpenScanModalIntro1} onCloseScanModalIntro1={onCloseScanModalIntro1}
                             onOpenScanModalIntro1={onOpenScanModalIntro1}/>
            <PricingScreen isOpenPricingScreen={isOpenPricingScreen}
                           onClosePricingScreen={onClosePricingScreen}
                           onOpenPricingScreen={onOpenPricingScreen}/>
        </div>
    );
};

export default Hamlet;







